import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "../../css/ContactUs.css";
import { fetchEmailConfig } from "../../api/emailApi";

/**
 * ContactUs component renders a contact form for users to reach out with questions.
 *
 * @component
 * @example
 * return (
 *   <ContactUs />
 * )
 */
const ContactUs = () => {
  const [formData, setFormData] = useState({
    from_name: "",
    from_email: "",
    subject: "",
    message: "",
  });

  const [emailConfig, setEmailConfig] = useState({
    serviceId: "",
    templateId: "",
    userId: "",
  });

  useEffect(() => {
    // Fetch EmailJS configuration from the backend
    const fetchConfig = async () => {
      try {
        const config = await fetchEmailConfig();
        setEmailConfig(config);
      } catch (error) {
        console.error("Failed to fetch EmailJS configuration:", error);
      }
    };

    fetchConfig();
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // must fill out form fully before sending message
    if (
      !formData.from_name ||
      !formData.from_email ||
      !formData.subject ||
      !formData.message
    ) {
      alert("Please fill out all fields before submitting the form.");
      return;
    }

    // validate email format
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(formData.from_email)) {
      alert("Please enter a valid email address.");
      return;
    }

    // sends email using EmailJS
    try {
      const response = await emailjs.send(
        emailConfig.serviceId,
        emailConfig.templateId,
        {
          from_name: formData.from_name,
          from_email: formData.from_email,
          subject: formData.subject,
          message: formData.message,
        },
        emailConfig.userId
      );

      if (response.status === 200) {
        alert("Message sent successfully!");
        // Clear form fields
        setFormData({
          from_name: "",
          from_email: "",
          subject: "",
          message: "",
        });
      } else {
        alert("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Failed to send message:", error);
      alert("Failed to send message.");
    }
  };

  return (
    <div className="ContactUs">
      {/* Header section */}
      <h1>have questions? let's connect!</h1>
      <h2>questions about pricing, features, or setup? we are here to help.</h2>

      {/* Contact form */}
      <form className="contact-us-form" onSubmit={handleSubmit}>
        {/* Name input field */}
        <label htmlFor="from_name">name</label>
        <input
          type="text"
          id="from_name"
          placeholder="enter name"
          value={formData.from_name}
          onChange={handleChange}
        />

        {/* Email input field */}
        <label htmlFor="from_email">email</label>
        <input
          type="email"
          id="from_email"
          placeholder="enter email"
          value={formData.from_email}
          onChange={handleChange}
        />

        {/* Subject input field */}
        <label htmlFor="subject">subject</label>
        <input
          type="text"
          id="subject"
          placeholder="enter subject"
          value={formData.subject}
          onChange={handleChange}
        />

        {/* Message textarea */}
        <label htmlFor="message">message</label>
        <textarea
          id="message"
          placeholder="enter message"
          value={formData.message}
          onChange={handleChange}
        ></textarea>

        {/* Submit button */}
        <button type="submit">send message</button>
      </form>
    </div>
  );
};

export default ContactUs;
